import React from "react";
import ReactTable from 'react-table-v6'
import Moment from 'moment';
import { Component, Fragment } from "react";

import {
	Card,
	CardBody,
	CardTitle,
	Col,
	Row,
	Progress,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	ButtonGroup,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
  Form,
  FormGroup,
  Label
} from 'reactstrap';

import update from 'react-addons-update';
import 'c3/c3.css';
import 'react-table-v6/react-table.css'
import { authenticationService } from '../../../jwt/_services';

class TopRecentRepairs extends React.Component {

	constructor(props) {
    super(props);

		const currentUser = authenticationService.currentUserValue;
		console.log('currentUser info: ' + JSON.stringify(currentUser));
		console.log('currentUser info: ' + JSON.stringify(currentUser.token));

    this.state = {
			repairLogs: [],
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
	  };

		//this.toggle4 = this.toggle4.bind(this);

  }

	async componentDidMount() {

    this.getData();
	}

	componentWillUnmount() {

	}

	goToRepairLog(id){
		window.location.href="/repair-log/"+id;
	}

	getData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-top-recent-repair-logs";

		if (this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']==1 && this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']!="us" && this.state.currentUser.payload['custom:market']!="us-azena") {
			console.log("top recent repairLogs Is International: " + JSON.stringify(this.state.currentUser.payload['custom:market']));
			url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-top-recent-repair-logs?Market="+this.state.currentUser.payload['custom:market'];
		}

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("top recent repairLogs: " + JSON.stringify(body));

			this.setState({loading: false});

			if (body.status == 'Success') {
				this.setState({ repairLogs: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

  render() {

		const data = this.state.repairLogs.map((prop, key) => {

			//const buf = Buffer.from(prop.detailedrepair, 'utf8');

			//buf.toString(); // 'Hello, World'

			return {
				id: key,
				repairId: prop.id,
				serialnum: prop.serialnum,
				batchnum: prop.batchnum,
				datecreated: Moment(prop.datecreated).format('MMM Do YYYY'),
				market: prop.market,
				Status: prop.Status,
				UPIClosed: prop.UPIClosed,
				CustomerName: prop.CustomerName,
				TrackingNum: prop.TrackingNum,
        LastModified: Moment(prop.LastModified).format('MMM Do YYYY'),
        LastModifiedTime: Moment(prop.LastModified).format("h:mm:ssa"),
			};
		});

		return (
			<Fragment>
        <Card className="card-hover">
          <CardBody>
            <Row className="mb-3">
              <Col md="12">
                <h3 style={{color:'#737782'}}>Last Viewed Repairs</h3>
              </Col>
            </Row>
						<ReactTable
						  style={{backgroundColor:'#000', padding:'10px', autocomplete: 'none'}}
							columns={[
								{
									Header: "ID",
									accessor: "repairId",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									minWidth: 15,
									Cell: row => (
						          <div style={{ textAlign: "center" }}>{row.value}</div>
						        )
								},
								{
									Header: "Serial",
									accessor: "serialnum",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									minWidth: 20,
									Cell: row => (
						          <div style={{ textAlign: "center" }}>{row.value}</div>
						        )
								},
								{
									Header: "Batch",
									accessor: "batchnum",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									minWidth: 20,
									Cell: row => (
						          <div style={{ textAlign: "center" }}>{row.value}</div>
						        )
								},
								{
									Header: "Date",
									accessor: "datecreated",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									minWidth: 25,
									Cell: row => (
						          <div style={{ textAlign: "center" }}>{row.value}</div>
						        )
								},
								{
									Header: "Market",
									accessor: "market",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									minWidth: 15,
									Cell: row => (
						          <div style={{ textAlign: "center" }}>{row.value}</div>
						        )
								},
								{
									Header: "UPI Closed?",
									accessor: "UPIClosed",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									minWidth: 35,
									Cell: row => (

										<div style={{ textAlign: "center" }}>
											{row.value==1 ? (
												<i style={{color: '#21c603'}} className="mdi mdi-checkbox-marked-outline mdi-24px"/>
											) : (
												<i style={{color: '#f62d51'}} className="mdi mdi-close-outline mdi-24px"/>
											)}
										</div>

						        )
								},
								{
									Header: "Customer Name",
									accessor: "CustomerName",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									minWidth: 60,
									Cell: row => (
						          <div style={{ textAlign: "center" }}>{row.value}</div>
						        )
								},
                {
									Header: "Last Modified Date",
									accessor: "LastModified",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									minWidth: 25,
									Cell: row => (
						          <div style={{ textAlign: "center" }}>{row.value}</div>
						        )
								},
                {
									Header: "Last Modified Time",
									accessor: "LastModifiedTime",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									minWidth: 25,
									Cell: row => (
						          <div style={{ textAlign: "center" }}>{row.value}</div>
						        )
								}
							]}
							defaultPageSize={10}
						  sortable={true}
							showPaginationBottom={false}
							className="-striped -highlight"
							data={data}
							getTrGroupProps={(state, rowInfo, column, instance) => {
	                    if (rowInfo !== undefined) {
	                        return {
	                            onClick: (e, handleOriginal) => {
	                              console.log('It was in this row:', rowInfo)
																console.log('with ID:', rowInfo.original.repairId);

																this.goToRepairLog(rowInfo.original.repairId);
	                            },
	                            style: {
	                                cursor: 'pointer'
	                            }
	                        }
	                    }}
	                }
						/>
          </CardBody>
        </Card>
			</Fragment>
		);
	}
}

export default TopRecentRepairs;
